import { render } from "./UserPoolView.vue?vue&type=template&id=eb96ece8&scoped=true&ts=true"
import script from "./UserPoolView.vue?vue&type=script&lang=ts"
export * from "./UserPoolView.vue?vue&type=script&lang=ts"

import "./UserPoolView.vue?vue&type=style&index=0&id=eb96ece8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb96ece8"]])

export default __exports__